module.exports = __webpack_public_path__ + "static/img/blues-g.42704997.png";